import Languages from '@shared/types/enums/languages';
import { createContext } from 'react';

const LanguageContext = createContext<{
  displayLanguage?: (language: Languages) => void;
  setLanguage?: (language?: Languages) => void;
}>({
  displayLanguage: () => null,
  setLanguage: () => null,
});

export default LanguageContext;
